import { style } from 'typestyle'
export const mb32 = style({ marginBottom: '32px' })
